<template>
  <div class="container">
    <div class="main">
      <!--p>
        Antes de comenzar, descarga el formato de archivos que debes subir para
        completar el módulo.
      </p-->
    </div>
    <div v-if="userPermissions" class="main container">
      <div class="buttons">
        <input
          type="file"
          ref="file"
          id="file-upload"
          @change="onChangeFileUpload"
        />
        <label for="file-upload" class="button-pill-up">
          <i class="bx bx-upload"></i> Subir
        </label>
      </div>
      <p v-if="file" class="archivo">{{ file.name }}</p>
      <b-button
        v-if="file"
        class="button-pill-up"
        @click="uploadFile"
        :disabled="loading"
        >Confirmar</b-button
      >
      <div v-if="loading" class="loading">
        <Loading />
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "../../../../components/tools/Loading.vue";
import axios from "axios";
import { mapState } from "vuex";

import { showAlert } from "../../../../components/tools/utils";
export default {
  components: {
    Loading,
  },
  data() {
    return {
      file: null,
      xfile: null,
      loading: false,
      userPermission: true,
      userPermissions: true,
    };
  },
  props: ["data", "getImagenServicioOrganigrama"],
    computed: {
    ...mapState("sesion", ["usuario"]),
  },
  methods: {
    uploadFile: async function() {
      if (!this.file) return;
      let formData = new FormData();
      formData.append("servicio", "" + this.$route.params.idServicio);
      formData.append("organigrama", this.file, this.file.name);
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 3000);
      try {
        await axios
          .post(
            `${process.env.VUE_APP_RUTA_API_IMG}/instituciones/servicios/organigrama/`,
            formData,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
                "content-type": "multipart/form-data",
              },
            }
          )
          .then(async (r) => {
            if (r.data) {
              showAlert({
                icon: "success",
                text: "Imagen subida correctamente",
                timerProgressBar: true,
                timer: 3000,
              });
              this.file = null;
              this.getImagenServicioOrganigrama();
            }
          })
          .catch((e) => {
            showAlert({
              icon: "error",
              text: e.response
                ? e.response.data[Object.keys(e.response.data)[0]]
                : "error",
              timerProgressBar: true,
              timer: 3000,
            });
            this.file = null;
          });
      } catch (error) {
        showAlert({
          icon: "error",
          text: error.response
            ? error.response.data[Object.keys(error.response.data)[0]]
            : "error",
          timerProgressBar: true,
          timer: 3000,
        });
        this.file = null;
      }
    },
    onChangeFileUpload(event) {
      this.xfile = event.target.files[0];
      if (this.xfile) {
        if (
          this.xfile.type === "image/jpg" ||
          this.xfile.type === "image/jpeg" ||
          this.xfile.type === "image/png" ||
          this.xfile.type === "image/svg+xml"
        ) {
          this.file = this.xfile;
        } else {
          this.file = null;
          showAlert({
            icon: "error",
            text: "Tipo de archivo invalido",
            timerProgressBar: true,
            timer: 3000,
          });
        }
      }
    },
    obtenerRevision: async function() {
      try {
        const toSend = process.env.VUE_APP_ANIO;
        console.log("To send", toSend);
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/revisiones/${this.$route.params.idServicio}/ultima_revision/`,
          {
            anio: toSend,
          },
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.datosUser = res.data;

        console.log("Hola mundo", this.datosUser);

        const relacionUs = this.usuario.servicios.find(
          (s) => s.id === this.$route.params.idServicio
        );
        if (!relacionUs) return;
        console.log("revisando user", relacionUs);
        //Guardar y finalizar Encargado BGI
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermission = false;
        }

        //Guardar y finalizar Jefe de Servicio
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermission = false;
        } else if (
          this.datosUser.a === undefined ||
          (this.datosUser.siguienteAccion === "jefe_servicio" &&
            relacionUs.rolId === 3)
        ) {
          this.userPermission = true;
        }

        // Guardar Borrador Encargado BGI
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermissions = false;
        }

        //Guardar funcionario
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 5)
        ) {
          this.userPermissions = false;
        }

        //Guardar Borrador Jefe de Servicio

        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermissions = false;
        } else if (
          this.datosUser.a === undefined ||
          (this.datosUser.siguienteAccion === "jefe_servicio" &&
            relacionUs.rolId === 3)
        ) {
          this.userPermissions = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    obtenerRelacionUsuarioServicios() {
      const relacionUs = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );
      if (!relacionUs) return;
      if (relacionUs.permisos.find((p) => p.permisoId === 5)) {
        this.userPermission = false;
      }
    },
  },
  mounted() {
    this.obtenerRevision();
    this.obtenerRelacionUsuarioServicios();
  },
};
</script>
<style scoped>
.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0 10px 0;
}
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.archivo {
  margin: 10px 0 !important;
}

.button-pill-up {
  margin-left: 10px;
  width: 150px;
  background: #4f52ff;
  border: none;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  color: white;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-pill-up:hover {
  background: #3d185f;
}
input[type="file"] {
  display: none;
}
i {
  margin-right: 4px;
}
.main-text {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #b8f4e9;
  height: 50px;
}
.main-text > h6 {
  font-weight: bold;
  color: #515151;
  margin: 0;
  text-align: center;
  margin: 15px;
}
</style>
